export default __webpack_public_path__ + "static/media/cauliflowerbites-wide.2053de8d.jpg";